import { ChevronDown } from "lucide-react";
import { ResolutionPicker } from "@/components/flowly/AspectRatioPicker/ResolutionPicker";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { BarControl } from "./BarControl";
import type { ResolutionControlProps } from "./types";

export function ResolutionControl({
  resolution,
  onResolutionChange,
  availableResolutions,
}: ResolutionControlProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <BarControl>
          <span className="text-white font-bold text-xs">
            {resolution.toUpperCase()}
          </span>
          <ChevronDown className="w-3 h-3 text-white/60" />
        </BarControl>
      </PopoverTrigger>
      <PopoverContent align="center" className="w-56 p-4 z-[60]">
        <ResolutionPicker
          resolution={resolution}
          onResolutionChange={onResolutionChange}
          availableResolutions={availableResolutions}
        />
      </PopoverContent>
    </Popover>
  );
}
